import Spinner from 'react-bootstrap/Spinner';
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import { Image, Schedule, Media, MediaGroup, MediaText, Block,Icon } from '..';
import DataTable from  '../../components/DataTable/DataTable';

export const tableColumns = [
    {
      name: "id",
      selector: (row) => row.customerid,
      sortable: false,
      hide : "lg",
      omit : true,

    },
    {
        name: "name",
        selector: (row) => row.name,
        sortable: true,                
    },
        
  ];

const ClientListSelect2 = ({clients,ClientsModal,closeClientsModal,clientSelect, title}) => {
  return (
    <Modal show={ClientsModal} onHide={closeClientsModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
           
               <Block>
     
                    <DataTable 
                        tableClassName="data-table-head-light table-responsive" 
                        pointerOnHover={true} 
                        data={clients}
                        columns={tableColumns} 
                        striped={true} 
                        highlightOnHover={true}  
                        filterFieldName="name" 
                        onRowClicked={(row,event)=>{ clientSelect(row) }} 
                    />   

              </Block>
            </Modal.Body>
            <Modal.Footer>              
            </Modal.Footer>
        </Modal>
  )
}

export default ClientListSelect2